// src/app/core/services/api.service.ts
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiService {
  //Lấy URL gốc của API từ file environment
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  private createHeaders(customHeaders?: any): HttpHeaders {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (customHeaders) {
      Object.keys(customHeaders).forEach(key => {
        headers = headers.set(key, customHeaders[key]);
      });
    }
    return headers;
  }

  get<T>(endpoint: string, params?: any, headers?: any): Observable<T> {
    const httpParams = new HttpParams({ fromObject: params || {} });
    return this.http.get<T>(`${this.baseUrl}/${endpoint}`, {
      params: httpParams,
      headers: this.createHeaders(headers),
    });
  }

  post<T>(endpoint: string, body: any, headers?: any): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/${endpoint}`, body, {
      headers: this.createHeaders(headers),
    });
  }

  put<T>(endpoint: string, body: any, headers?: any): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${endpoint}`, body, {
      headers: this.createHeaders(headers),
    });
  }

  delete<T>(endpoint: string, headers?: any): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}/${endpoint}`, {
      headers: this.createHeaders(headers),
    });
  }

postFormData<T>(endpoint: string, formData: FormData, headers?: any): Observable<T> {
  // Không set Content-Type để browser tự xử lý multipart boundary
  let httpHeaders = new HttpHeaders();
  if (headers) {
    Object.keys(headers).forEach(key => {
      httpHeaders = httpHeaders.set(key, headers[key]);
    });
  }
  return this.http.post<T>(`${this.baseUrl}/${endpoint}`, formData, {
    headers: httpHeaders
  });
}

}
